export default "__VITE_ASSET__d76be644__"